import {
  RequestBasketballPostPracticeHelpouts,
  RequestBasketballUpdatePracticeNominees,
} from '@hefe/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../../api/api';

const setBasketballPracticeNominees = createAsyncThunk(
  'basketballPractices/setNominees',
  async (
    data: {
      practice_id: number;
      data: RequestBasketballUpdatePracticeNominees;
    },
    thunkAPI
  ) => {
    const response = await API.basketballPractices().updateNominees(
      data.practice_id,
      data.data
    );
    return response?.data;
  }
);

const setBasketballPracticeHelpouts = createAsyncThunk(
  'basketballPractices/setHelpouts',
  async (data: RequestBasketballPostPracticeHelpouts, thunkAPI) => {
    const response = await API.basketballPractices().updateHelpouts(data);
    return response?.data;
  }
);

export { setBasketballPracticeNominees, setBasketballPracticeHelpouts };
